import { forwardRef } from 'react'
import { Bubble } from './chat-message.styles'
import { getLinkifiedChatMessageSegments } from './chat-message-linkify'
import type { ChatMessageProps } from './chat-message.types'

export const ChatMessage = forwardRef<HTMLTdsCardElement, ChatMessageProps>(
  function ChatMessage(
    {
      children,
      message,
      id,
      imagePlacement,
      rightPosition = false,
      imageUrl,
      onMessageClick,
      hasThumbnail,
      onContextMenu,
      onLongTouch
    }: Readonly<ChatMessageProps>,
    ref
  ) {
    let longPressTimer: NodeJS.Timeout

    return (
      <Bubble
        id={id}
        ref={ref}
        onTouchStart={e => {
          longPressTimer = setTimeout(() => {
            onLongTouch?.(e)
          }, 500)
        }}
        onTouchEnd={() => {
          clearTimeout(longPressTimer)
        }}
        onTouchMove={() => {
          clearTimeout(longPressTimer)
        }}
        right={rightPosition}
        imagePlacement={imagePlacement}
        body-img={!hasThumbnail ? imageUrl : null}
        onClick={onMessageClick}
        onContextMenu={e => {
          onContextMenu?.(e)
        }}
      >
        <div slot='header'>
          {getLinkifiedChatMessageSegments(message).map((segment, index) =>
            segment.url ? (
              <a
                key={`${segment.url}-${index}`}
                href={segment.url}
                target='_blank'
                rel='noreferrer'
                onClick={event => {
                  event.stopPropagation()
                }}
              >
                {segment.text}
              </a>
            ) : (
              <span key={`text-${index}`}>{segment.text}</span>
            )
          )}
        </div>
        {hasThumbnail && imageUrl && (
          <img slot='thumbnail' src={imageUrl} alt='Thumbnail for the card.' />
        )}
        <div slot='body'>{children}</div>
      </Bubble>
    )
  }
)
